import React from 'react';

import { Container, WrapperFullHeight } from './styles';
import FooterWrapper from '../../../../components/FooterWrapper';
import { Button } from '../../../../components';
import { usePlatformContext } from '../../../../contexts/PlatformContext';
import { Conclusion } from '../../../../components/Icons/Conclusion';
import useOnCloseSchedule from '../../../../hooks/useOnCloseSchedule';

export const AppointmentConclusion = () => {
  const { clearData } = usePlatformContext();
  const { onCloseSchedule } = useOnCloseSchedule({});

  return (
    <Container>
      <WrapperFullHeight>
        <Conclusion />
        <h1 className="title">Agendamento realizado com sucesso!</h1>
      </WrapperFullHeight>
      <FooterWrapper>
        <Button
          title="Fechar"
          onClick={() => {
            clearData();
            onCloseSchedule();
          }}
        />
      </FooterWrapper>
    </Container>
  );
};
